import { render, staticRenderFns } from "./ProductSelectT4.vue?vue&type=template&id=3a4d87ca&"
import script from "./ProductSelectT4.vue?vue&type=script&lang=js&"
export * from "./ProductSelectT4.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelectT4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports